import _uniqBy from 'lodash/uniqBy';
import _isObject from 'lodash/isObject';
import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import _toNumber from 'lodash/toNumber';
import _conforms from 'lodash/conforms';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { contactByEmail } from '../actions/action-contact-option';
import ContactOption from '../components/ContactOption';
import contentHelper from '../../lib/contentHelper';
import messageHelper from '../../lib/messageHelper';
import { loadModalContainer } from '../actions/action-login-modal';
import { locationUpdate } from '../actions/action-contact-location';
import { trackLink } from '../../lib/analytics-helper';
import * as shape from '../constants/PropTypesShapes';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';

const noTopicStyle = {
  textAlign: 'center',
  marginTop: '20px',
};

const mainHeading = i18n.message('smarthelp/channelSelection.contactUs.header');

const resolution = {
  label: i18n.message('smarthelp/contactLinksOption.label.resolution'),
  message: i18n.message('smarthelp/contactLinksOption.message.resolution'),
  link: 'https://www.paypal.com/signin/?returnUri=https%3A%2F%2Fwww.paypal.com%2Fcgi-bin%2Fwebscr%3Fcmd%3D_complaint-view',
};

let openChat;

const ChannelType = {
  CALLUS: 'callus',
  COMMUNITY: 'community',
  EMAIL: 'email',
  CHAT: 'chat',
  RESOLUTION: 'seller',
};

export class ContactOptionsContainer extends Component {
  // Error case initial state
  static errorContactChannels() {
    const callUs = {
      type: 'callus',
    };
    const communityOptions = {
      type: 'community',
    };
    return Page.getCommunitySearchURL() ? [callUs, communityOptions] : [callUs];
  }

  // Event handler for clicking resolution icon
  static getResolutionAction(fptiLink) {
    return () => {
     // const link = 'smarthelp-contact-option-selection|resolution';
      trackLink({ id: 'contactUsPage', fptiLink });
      window.open(resolution.link, '_blank');
    };
  }

  // Line break rule for contact panels
  static contactPanelsLineBreak(contactOptions) {
    const contactOptionNum = contactOptions.length;
    return classNames({
      'contact-panels': true,
      'contact-panels-four-padding': contactOptionNum === 4,
      'contact-panels-five-padding': contactOptionNum === 5,
    });
  }

  static getChatAction(selectResult) {
    return openChat('/smarthelp/node-chat/home', `${selectResult.topicRefId}`);
  }

  // remove contact option duplicate key
  static removeContactDuplicate(contactOptions) {
    return _uniqBy(contactOptions, 'type');
  }

  constructor(props) {
    super(props);
    this.emailMessage = messageHelper(props.content.emailUs.loggedOutMessage, props.content.emailUs.loggedInMessage);
    this.contactMessage = props.content.callUs.loggedInMessage;
    this.state = {
      isLoggedIn: document.body.getAttribute('isloggedin'),
    };
    // eslint-disable-next-line no-undef
    if (chatOpener) { // eslint-disable-next-line no-undef
      openChat = chatOpener.openChat('/smarthelp/node-chat/chat/check-session');
    }
  }
  getSearchTerm() {
    return this.props.selectResult ? `${this.props.selectResult.topicRefId}` : '';
  }

  getCommunityMessage() {
    return this.props.activeCommunityUserCount > 0 ? contentHelper(this.props.content.community.online, { onlineMember: this.props.activeCommunityUserCount }) : '';
  }
  getChatMessage() {
    return contentHelper(this.props.content.chat.waitTime, { time: this.props.waitTime });
  }
  getCommunityAction(searchTerm, rank) {
    return () => {
      if (searchTerm) {
        const link = `smarthelp-contact-option-selection|community|index-${rank}|${searchTerm}`;
        trackLink({ id: 'contactUsPage', link: this.getRecommendChannelName(link) });
        window.open(contentHelper(Page.getCommunitySearchURL(), { searchTerm }));
      } else {
        const link = `smarthelp-contact-option-selection|community|index-${rank}`;
        this.trackFPTIIncompletedFlow(this.getRecommendChannelName(link));
        window.open(Page.getCommunityLink());
      }
    };
  }

  getChannelAction(channelName, rank) {
    switch (channelName) {
      case 'email' :
        return () => {
          if (this.props.selectResult) {
            this.showEmailUs(rank);
          } else {
            this.showEmailUsNoIntent();
          }
        };
      case 'callus' :
        return () => {
          this.showCallUs(rank);
        };
      case 'community': {
        const searchTerm = this.props.selectResult ? `${this.props.selectResult.topicName}` : '';
        return this.getCommunityAction(searchTerm, rank);
      }
      case 'chat' : {
        return this.showChat(rank, this.props.selectResult);
      }
      case 'seller': {
        const link = this.getRecommendChannelName('smarthelp-contact-option-selection|resolution');
        return ContactOptionsContainer.getResolutionAction(link);
      }
      default :
        return () => {};
    }
  }
  getRecommendChannelName(link) {
    let channelName = this.getContactOptionsChannel();
    // If there is no contact option get from API, then using [callus, community] as default case
    if (Array.isArray(channelName) && channelName.length === 0) {
      channelName = ContactOptionsContainer.errorContactChannels();
    }

    if (_isObject(this.props.selectResult) && Array.isArray(channelName) && channelName.length > 0) {
      return `${link}|rec-${channelName[0].type}`;
    }
    return link;
  }

  getContactChannel(channelName, index) {
    const recommended = index === 0 && _isObject(this.props.selectResult);
    switch (channelName) {
      case 'email' : {
        return (<ContactOption
          key="email"
          id="contact-email-option"
          contactLinkCSS="btn vx_btn-link contact-link"
          iconClass="btn vx_btn-link icon-emailus"
          text={this.props.content.emailUs.header}
          message={this.isCompaintEnabled() ? '' : this.emailMessage}
          supportMessageCSS="support-message"
          clickAction={this.getChannelAction('email', index)}
          recommended={recommended}
        />);
      }
      case 'callus' : {
        return (<ContactOption
          key="callus"
          id="contact-callus-option"
          contactLinkCSS="btn vx_btn-link contact-link"
          iconClass="btn vx_btn-link icon-callus"
          text={this.props.content.callUs.header}
          message={this.contactMessage}
          supportMessageCSS="support-message"
          clickAction={this.getChannelAction('callus', index)}
          recommended={recommended}
        />);
      }
      case 'community' :
        return (<ContactOption
          key="community"
          id="contact-community-option"
          iconClass="btn vx_btn-link icon-community"
          contactLinkCSS="btn vx_btn-link contact-link"
          text={this.props.content.community.header}
          message={this.getCommunityMessage()}
          supportMessageCSS="support-message"
          clickAction={this.getChannelAction('community', index)}
          recommended={recommended}
        />);
      case 'chat' :
        if (this.isChatEnabled()) {
          return (<ContactOption
            key="chat"
            id="contact-chat-option"
            iconClass="btn vx_btn-link icon-chat"
            contactLinkCSS="btn vx_btn-link contact-link"
            text={this.props.content.chat.header}
            message={this.getChatMessage()}
            supportMessageCSS="support-message"
            clickAction={() => this.getChannelAction('chat', index)}
            toolTip
            recommended={recommended}
          />);
        }
        return null;

      case 'seller' :
        return (<ContactOption
          key="resolution"
          id="contact-resolution-option"
          contactLinkCSS="btn vx_btn-link contact-link"
          iconClass="btn vx_btn-link icon-resolution"
          text={resolution.label}
          message={resolution.message}
          supportMessageCSS="support-message"
          clickAction={this.getChannelAction('seller')}
          recommended={recommended}
        />);
      default:
        return <div />;
    }
  }

  getContent() {
    let content = null;
    if (this.props.display) {
      let heading = Page.isTopicTreeDisabled() && mainHeading;
      if (!heading) {
        heading = this.props.selectResult ? this.props.content.header : this.props.content.alterHeader;
      }
      content = (
        <div>
          <div className="col-xs-0 col-sm-1 col-md-1 col-lg-1" />
          <div className="contact-options col-xs-12 col-sm-10 col-md-10 col-lg-10" style={Page.isTopicTreeDisabled() ? noTopicStyle : {}} >
            <div className="call-header" >
              { heading }
            </div >
            {this.renderContactChannels()}
          </div >
        </div>);
    }
    return content;
  }

  // Display IDI contact option when IDI option is availabel and reach to topic node leaf selection
  getContactOptionsChannel() {
    // To check the email option exist from the SAC
    const emailOptionValidate = Array.isArray(this.props.formFields) && this.props.formFields.length > 0;
    /**
     * Filter out:
     * 1) the email option in the IDI, if the email form data not in the SAC
     * 2) Empty IDI object
     */
    const IDIContactChannels = _filter(this.props.IDIContactChannels, channel => (
      !((channel.type === ChannelType.EMAIL && !emailOptionValidate) || _isEmpty(channel))
    ));
    if (this.props.IDIEnable && Array.isArray(IDIContactChannels) && IDIContactChannels.length > 0 && this.props.reachToResult) {
      return IDIContactChannels;
    }
    return this.props.contactChannels;
  }
  isChatEnabled() {
    return Page.isLoggedIn && this.props.isChatEnabled && Page.isDesktopLayout();
  }

  isCompaintEnabled() {
    return Page.isComplaintEnabledMarket() && document.body.getAttribute('isloggedin') && this.props.topicTreeSelectionL1Reference === 'formal_complaints_l1';
  }

  trackFPTIIncompletedFlow(link) {
    let trackingLink = link;
    if (this.props.topicTreeSelectionL1) {
      trackingLink = `${link}|${this.props.topicTreeSelectionL1}`;
      if (this.props.topicTreeSelectionL2) {
        trackingLink = `${link}|${this.props.topicTreeSelectionL2}`;
      }
    }
    trackLink({ id: 'contactUsPage', link: trackingLink });
  }

  redirectToSelfHelp(contactOption) {
    this.trackFPTIIncompletedFlow(`smarthelp-contact-option-redirect-selfhelp|${contactOption}`);
    const cobrand = Page.getCountry();
    const redirectLink = `/${cobrand}/selfhelp/contact/${contactOption}`;
    Page.goTo(redirectLink);
  }
  showChat(rank, selectResult) {
    const searchTerm = this.getSearchTerm();
    const link = searchTerm && searchTerm !== '' ? `smarthelp-contact-option-selection|chat|index-${rank}|${searchTerm}` : `smarthelp-contact-option-selection|chat|index-${rank}`;
    trackLink({ id: 'chat', link: this.getRecommendChannelName(link) });
    return ContactOptionsContainer.getChatAction(selectResult);
  }
  showCallUs(rank) {
    const searchTerm = this.getSearchTerm();
    const link = searchTerm && searchTerm !== '' ? `smarthelp-contact-option-selection|call-us|index-${rank}|${searchTerm}` : `smarthelp-contact-option-selection|call-us|index-${rank}`;
    if (!this.state.isLoggedIn) {
      trackLink({ id: 'intermediatePage', link: this.getRecommendChannelName(link) });
      return this.props.loadModalContainer('callUs');
    }

    trackLink({ id: 'callUsPage', link: this.getRecommendChannelName(link) });
    return this.props.locationUpdate({ pageName: 'callUs' });
  }

  showEmailUsNoIntent() {
    if (!this.state.isLoggedIn) {
      return this.props.loadModalContainer('email');
    }
    return this.props.locationUpdate({ pageName: 'email' });
  }

  showEmailUs(rank) {
    const searchTerm = this.getSearchTerm();
    const link = searchTerm && searchTerm !== '' ? `smarthelp-contact-option-selection|email-us|index-${rank}|${searchTerm}` : `smarthelp-contact-option-selection|email-us|index-${rank}`;

    if (!this.state.isLoggedIn) {
      trackLink({ id: 'intermediatePage', link: this.getRecommendChannelName(link) });
      return this.props.loadModalContainer('emailUs');
    }

    trackLink({ id: 'emailPage', link: this.getRecommendChannelName(link) });
    return this.props.contactByEmail(this.props.formFields);
  }

  filterContactChannels() {
    const contactOptions = this.sortContactChannels();
    return _filter(contactOptions,
      _conforms({
        type: type => ((Page.getCommunityLink() && Page.getCommunitySearchURL()) || type !== 'community') && (type !== 'chat' || (this.isChatEnabled())),
      }));
  }

  sortContactChannels() {
    return this.getContactOptionsChannel().sort((channel1, channel2) => (
      _toNumber(channel1.priority) - _toNumber(channel2.priority)
    ));
  }

  renderContactPanels(contactOptions) {
    const tempOptions = ContactOptionsContainer.removeContactDuplicate(contactOptions);
    return (
      <div className={ContactOptionsContainer.contactPanelsLineBreak(tempOptions)}>
        {tempOptions.map((channel, index) => this.getContactChannel(channel.type, index))}
      </div>
    );
  }

  renderContactChannels() {
    const filteredContactChannels = this.filterContactChannels();
    if (!this.props.isLoading && Array.isArray(filteredContactChannels) && filteredContactChannels.length === 0) {
      return this.renderContactPanels(ContactOptionsContainer.errorContactChannels());
    }
    return this.renderContactPanels(filteredContactChannels);
  }

  render() {
    return this.getContent();
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.isLoading,
    content: window.localeBundle ? window.localeBundle['smarthelp/contactOption'] : {},
    contactChannels: state.contactChannels.channels,
    IDIEnable: state.contactChannels.IDIEnable,
    IDIContactChannels: state.contactChannels.IDIChannels,
    formFields: state.emailForm.fields,
    display: state.contactChannels.display,
    activeCommunityUserCount: state.activeCommunityUserCount.count,
    selectResult: state.selectResult.topicTreeSelectResult,
    isModalOpen: state.modal.isModalOpen,
    topicTreeSelectionL1: state.topicTree.topicTreeSelectionL1 ? state.topicTree.topicTreeSelectionL1.topic_name : undefined,
    topicTreeSelectionL2: state.topicTree.topicTreeSelectionL2 ? state.topicTree.topicTreeSelectionL2.topic_name : undefined,
    topicTreeSelectionL1Reference: state.topicTree.topicTreeSelectionL1 ? state.topicTree.topicTreeSelectionL1.ref_id : undefined,
    isChatEnabled: state.chat.chatEnabled,
    waitTime: state.chat.waitTime,
    reachToResult: state.contactChannels.reachToResult,
  };
}

ContactOptionsContainer.propTypes = {
  isLoading: PropTypes.bool,
  content: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  contactChannels: PropTypes.arrayOf(PropTypes.shape(shape.CONTACT_OPTION)),
  IDIEnable: PropTypes.bool,
  IDIContactChannels: PropTypes.arrayOf(PropTypes.shape(shape.CONTACT_OPTION)),
  formFields: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  activeCommunityUserCount: PropTypes.number,
  locationUpdate: PropTypes.func.isRequired,
  loadModalContainer: PropTypes.func.isRequired,
  selectResult: PropTypes.shape(shape.SELECT_RESULT),
  contactByEmail: PropTypes.func.isRequired,
  display: PropTypes.bool,
  topicTreeSelectionL1: PropTypes.string,
  topicTreeSelectionL2: PropTypes.string,
  topicTreeSelectionL1Reference: PropTypes.string,
  waitTime: PropTypes.number,
  isChatEnabled: PropTypes.bool,
  reachToResult: PropTypes.bool,
};

ContactOptionsContainer.defaultProps = {
  isLoading: false,
  contactChannels: [],
  IDIEnable: false,
  IDIContactChannels: [],
  formFields: [],
  activeCommunityUserCount: 0,
  selectResult: undefined,
  display: false,
  topicTreeSelectionL1: undefined,
  topicTreeSelectionL2: undefined,
  topicTreeSelectionL1Reference: undefined,
  waitTime: 0,
  isChatEnabled: false,
  reachToResult: false,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ contactByEmail, loadModalContainer, locationUpdate }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ContactOptionsContainer);
